import React from 'react'

const ViewProjects = () => {
  return (
    <section className='md:mr-2 h-full'>
       <h1 className='py-1 text-xl text-white bg-green-small font-semibold pl-3 uppercase'>View Campaigns </h1>
       <div className='mt-[9rem] md:mt-[12rem]'>
            <h5 className='text-xl text-center'> View Campaigns list </h5>
        </div>
    </section>
  )
}

export default ViewProjects